import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import Navbar from 'react-bootstrap/lib/Navbar';
import NavbarToggle from 'react-bootstrap/lib/NavbarToggle';
import { LinkContainer } from 'react-router-bootstrap';
import './NavigationBar.css';
import { withTranslation } from 'react-i18next';
import { isTouchScreen } from '../../utils/is-touch-screen';
import {
  isModuleVisible,
  Modules,
} from '../../utils/module-controller';
import onClickOutside from 'react-onclickoutside';
import { PERMISSION } from '../../modules/newAuth/model/User';

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownMenuOpen: false,
    };
  }

  handleClickOutside = evt => {
    this.setState({ isDropdownMenuOpen: false });
  };

  get isBatchPage() {
    const { location } = this.props;
    if (!location || !location.pathname) {
      // Default to true for batch page when location is not yet available
      return true;
    }
    const { pathname } = location;
    return pathname === '/' || String(pathname).includes('index') || pathname === '/auth/sso'; // After login, the pathname might be '/auth/sso' (after initial SSO redirect)
  }

  get logMeInSupportLink () {
    const { newAuthStore, locationsStore } = this.props;
    const plantName = locationsStore.currentPlant.description;
    const email = newAuthStore.user.email;
    return `https://secure.logmeinrescue.com/Customer/Download.aspx?EntryID=185000112&name=${email}&comment1=CloudBatch&comment2=${plantName}`;
  }

  toggleDropdownMenu = () => {
    this.setState({ isDropdownMenuOpen: !this.state.isDropdownMenuOpen });
  };

  render() {
    const { sidebarStore, newAuthStore, batchStore, t } = this.props;
    const { isDropdownMenuOpen } = this.state;
    const { logoFile } = newAuthStore.companyConfig;
    const canEditDevices = newAuthStore.user?.hasAccess(PERMISSION.BATCH_DEVICE);

    return (
      <Navbar fluid fixedTop className="page-header" collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Header>
          <div className="page-logo">
            <Link to="/" className="navbar-brand">
              <img alt="" src={`data:image/png;base64,${logoFile}`}/>
            </Link>
          </div>
          <NavbarToggle aria-controls="responsive-navbar-nav" />
        </Navbar.Header>
        <Navbar.Collapse id="responsive-navbar-nav">
          <div className="top-menu">
            {this.isBatchPage && (
              <Nav className="mr-auto">
                {isModuleVisible(Modules.TEST_MODE) && batchStore.isTestMode && (
                  <NavItem
                    className="dropdown"
                    onClick={() => sidebarStore.onToggle('testMode')}
                  >
                    <i className="fa fa-check-circle" />
                  </NavItem>
                )}
                <NavItem
                  className="dropdown"
                  onClick={() => sidebarStore.onToggle('schedules')}
                >
                  <i className="fa  fa-clock"/>
                </NavItem>
                {canEditDevices && (
                  <NavItem className="dropdown visible-xs-block"
                    onClick={() => sidebarStore.onToggle('devices')}>
                    <i className="fa fa-gears"/>
                  </NavItem>
                )}
                {!isTouchScreen() && isModuleVisible(Modules.LOGIC_EDITOR) && (
                  <NavItem
                    className="dropdown visible-xs-block"
                    onClick={() => sidebarStore.onToggle('editor')}
                  >
                    <i className="fa fa-code"/>
                  </NavItem>
                )}
                {isModuleVisible(Modules.DIAGNOSE) && (
                  <NavItem
                    className="dropdown visible-xs-block"
                    onClick={() => sidebarStore.onToggle('diagnose')}
                  >
                    <i className="fa fa-medkit"/>
                  </NavItem>
                )}
              </Nav>
            )}
            <Nav className="mr-auto" style={{ position: 'relative' }}>
              <NavItem
                className="dropdown hidden-xs"
                onClick={this.toggleDropdownMenu}
              >
                <i className="fa fa-navicon" aria-hidden="true"/>
              </NavItem>
              <NavItem
                className="dropdown visible-xs-block"
                onClick={batchStore.onBeforeLogout}
              >
                <i className="icon-power"/>
              </NavItem>
            </Nav>
            { isDropdownMenuOpen && (
              <ul className="nav-dropdown-menu">
                {canEditDevices && (
                  <li
                    className="nav-dropdown-menu__item"
                  >
                    <a
                      className="dropdown"
                      onClick={() => sidebarStore.onToggle('devices')}
                    >
                      <i className="fa fa-gears"/>
                      {t('Devices')}
                    </a>
                  </li>
                )}
                {!isTouchScreen() && isModuleVisible(Modules.LOGIC_EDITOR) && (
                  <li
                    className="nav-dropdown-menu__item"
                  >
                    <a
                      className="dropdown"
                      onClick={() => sidebarStore.onToggle('editor')}
                    >
                      <i className="fa fa-code" />
                      {t('Logic Editor')}
                    </a>
                  </li>
                )}
                {isModuleVisible(Modules.DIAGNOSE) && (
                  <li
                    className="nav-dropdown-menu__item"
                  >
                    <a
                      className="dropdown"
                      onClick={() => sidebarStore.onToggle('diagnose')}
                    >
                      <i className="fa fa-medkit"/>
                      {t('Diagnose')}
                    </a>
                  </li>
                )}
                <li
                  className="nav-dropdown-menu__item"
                >
                  <a
                    href={this.logMeInSupportLink}
                    rel="noreferrer"
                    target={'_blank'}
                  >
                    <i className="fa fa-phone" aria-hidden="true"/>
                    {t('Support')}
                  </a>
                </li>
                <li
                  className="nav-dropdown-menu__item"
                >
                  <a
                    onClick={batchStore.onBeforeLogout}
                  >
                    <i className="fa fa-power-off" aria-hidden="true"/>
                    {t('Log Out')}
                  </a>
                </li>
              </ul>
            )}
          </div>
          <div id="navigation-bar-main-menu" className="hor-menu">
            <Nav>
              {isModuleVisible(Modules.BATCH) && (
                <LinkContainer exact to="/">
                  <NavItem>{t('nav.Batch')}</NavItem>
                </LinkContainer>
              )}
              {isModuleVisible(Modules.MIXES) && (
                <LinkContainer exact to="/mixes">
                  <NavItem>{t('nav.Mix')}</NavItem>
                </LinkContainer>
              )}
              {isModuleVisible(Modules.MATERIALS) && (
                <LinkContainer exact to="/materials">
                  <NavItem>{t('nav.Materials')}</NavItem>
                </LinkContainer>
              )}
              {isModuleVisible(Modules.TICKETS) && (
                <LinkContainer exact to="/tickets">
                  <NavItem>{t('nav.Ticket')}</NavItem>
                </LinkContainer>
              )}
              {isModuleVisible(Modules.DISCHARGE) && (
                <LinkContainer exact to="/discharge">
                  <NavItem>{t('nav.Discharge')}</NavItem>
                </LinkContainer>
              )}
              {isModuleVisible(Modules.SETTINGS) && (
                <LinkContainer exact to="/settings">
                  <NavItem>{t('nav.Settings')}</NavItem>
                </LinkContainer>
              )}
            </Nav>
          </div>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default withTranslation()(inject('sidebarStore', 'newAuthStore', 'batchStore', 'locationsStore')(observer(onClickOutside(NavigationBar))));
